var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouseFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70.000000pt",
    height: "70.000000pt",
    viewBox: "0 0 70.000000 70.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,70.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275 683 c-24 -23 -14 -83 22 -141 45 -73 116 -83 148 -21 25 48 -1 100 -77 152 -47 31 -70 34 -93 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 619 c-14 -26 -15 -95 -2 -130 26 -66 117 -92 160 -46 44 47 22 108 -61 168 -47 34 -82 37 -97 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 520 c-12 -14 -20 -41 -23 -79 -4 -54 -2 -59 23 -79 36 -28 76 -28 102 1 44 48 35 98 -27 151 -38 31 -51 32 -75 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 322 c-19 -15 -22 -25 -16 -53 11 -63 113 -137 162 -119 54 21 73 109 32 148 -48 44 -138 56 -178 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 291 c-11 -5 -28 -18 -38 -29 -16 -18 -17 -27 -8 -77 9 -46 8 -62 -5 -87 -18 -36 -15 -77 8 -91 13 -9 50 4 170 60 84 39 157 78 163 87 14 22 -5 37 -56 42 -74 9 -82 12 -139 59 -57 47 -62 49 -95 36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseFoot);
export default __webpack_public_path__ + "static/media/mouse_foot.9344ef381ec9cefffdd59f3ff905b84b.svg";
export { ForwardRef as ReactComponent };